var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrmIconExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06667 13.067L12.0923 13.067L9.64623 15.513C9.22952 15.9297 9.22952 16.6047 9.64623 17.0215C10.0629 17.4382 10.738 17.4382 11.1547 17.0215L15.4203 12.7559C15.5193 12.6572 15.5979 12.539 15.6521 12.4076C15.7598 12.147 15.7598 11.8536 15.6521 11.593C15.5977 11.4616 15.5193 11.3434 15.4203 11.2447L11.1547 6.97913C10.738 6.56242 10.0629 6.56242 9.64623 6.97913C9.43788 7.18748 9.3337 7.46055 9.3337 7.73344C9.3337 8.00633 9.43788 8.2794 9.64623 8.48758L12.0923 10.9336L5.06667 10.9336C4.47698 10.9336 4 11.4108 4 12.0003C4 12.5898 4.4768 13.067 5.06667 13.067ZM17.8665 6.66654L17.8667 17.3341V18.4008C17.8667 18.9903 18.3438 19.4675 18.9333 19.4675C19.5228 19.4675 20 18.9905 20 18.4008L20 5.59987C20 5.01036 19.523 4.5332 18.9332 4.5332C18.3436 4.5332 17.8665 5.01036 17.8665 5.59987C17.8665 5.83295 17.8665 6.04846 17.8665 6.22386C17.8666 6.4921 17.8666 6.66654 17.8665 6.66654Z",
    fill: "#6F7687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrmIconExpand);
export default __webpack_public_path__ + "static/media/irm-icon-expand.dff547d19794d4248ffb0fc5dffd0f1d.svg";
export { ForwardRef as ReactComponent };